let autoTypeList = [];
let autoBouwjaarList = [];
let hondenrasList = [];

Promise.all([
  fetch('https://ak.hundos.info/api/brands?site=autobench.nl'),
  fetch('https://ak.hundos.info/api/types'),
  fetch('https://ak.hundos.info/api/modelyears'),
  fetch('https://ak.hundos.info/api/dogbreeds')
])
  .then(function (responses) {
    // Get a JSON object from each of the responses
    return Promise.all(
      responses.map(function (response) {
        return response.json();
      })
    );
  })
  .then(function (data) {
    let carBrandSelector = document.getElementById("carBrandSelector");
    let carTypeSelector = document.getElementById("carTypeSelector");
    let dogbreedSelector = document.getElementById("dogbreedSelector");
    let modelyearSelector = document.getElementById("modelyearSelector");
    // merken
    data[0].forEach((auto) => {
      let option = document.createElement("option");
      option.className = auto["name"];
      option.value = auto["name"];
      option.innerText = auto["name"];
      carBrandSelector.appendChild(option);
    });
    // types
    data[1].forEach((type) => {
      let option = document.createElement("option");
      option.className = type["brand"]["name"];
      option.innerText = type["name"];
      option.value = (type["brand"]["name"] + "-" + type["name"]).toLowerCase();
      autoTypeList.push(option);
      carTypeSelector.appendChild(option);
    });
    // bouwjaar
    data[2].forEach((bouwjaar) => {
      let option = document.createElement("option");
      option.className = bouwjaar["type_name"];
      option.innerText = bouwjaar["name"];
      if (bouwjaar['slug'] != null) {
        option.value = bouwjaar["slug"].toLowerCase();
      } else {
        option.value = bouwjaar["name"].toLowerCase();
      }
      autoBouwjaarList.push(option);
      modelyearSelector.appendChild(option);
    });
  })
  .catch(function (error) {
    console.log(error);
  });

function getCorrectSubCats() {
  const categorySelected = document.getElementById("carBrandSelector");
  const subCategorySelect = document.getElementById("carTypeSelector");
  subCategorySelect.disabled = false;
  subCategorySelect.innerHTML = "";
  for (subcatOption in autoTypeList) {
    if (autoTypeList[subcatOption].className == categorySelected.value) {
      subCategorySelect.appendChild(autoTypeList[subcatOption]);
    }
  }
  if (subCategorySelect.innerHTML == "") {
    subCategorySelect.innerHTML =
      "<option value=''>Geen autotype beschikbaar</option>";
  }
  getCorrectBouwjaar();
}
function getCorrectBouwjaar() {
  const subCategorySelected = document.getElementById("carTypeSelector");
  const bouwjaarSelect = document.getElementById("modelyearSelector");
  bouwjaarSelect.disabled = false;
  bouwjaarSelect.innerHTML = "";
  let text =
    subCategorySelected.options[subCategorySelected.selectedIndex].text;
  for (subcatOption in autoBouwjaarList) {
    if (autoBouwjaarList[subcatOption].className == text) {
      bouwjaarSelect.appendChild(autoBouwjaarList[subcatOption]);
    }
  }
  if (bouwjaarSelect.innerHTML == "") {
    bouwjaarSelect.innerHTML =
      "<option value=''>Geen auto bouwjaar beschikbaar</option>";
  }
}
function sanitizeSlug(value) {
  return value
    .replace(".", "")
    .replace(",", "")
    .replace("?", "")
    .replace("!", "")
    .replace("+", "")
    .replace(" & ", "-")
    .replace("- ", "-")
    .replace(" -", "-")
    .replace(" - ", "-")
    .replace("(", "")
    .replace(")", "")
    .replace(/ /g, "-")
    .replace(/-+$/, "");
}

function showAutoPage() {
  let carBrandSelector = document.getElementById("carBrandSelector");
  let carTypeSelector = document.getElementById("carTypeSelector");
  let dogbreedSelector = document.getElementById("dogbreedSelector");
  let modelyearSelector = document.getElementById("modelyearSelector");
  let tempModelYearText = modelyearSelector.value;
  // console.log(carTypeSelector.value);
  if (carTypeSelector.value == "" && carBrandSelector.value == "") {
    window.location.href = "/collections/auto";
  } else if (carTypeSelector.value == "") {
    window.location.href = "/collections/" + carBrandSelector.value;
  } else if (modelyearSelector.value == "") {
    window.location.href = "/collections/" + carTypeSelector.value;
  } else {
    if (modelyearSelector.value[modelyearSelector.value.length - 2] == "-") {
      // console.log(modelyearSelector.value);
      tempModelYearText = modelyearSelector.value.replace("-", "");
      // console.log(tempModelYearText);
      alert(tempModelYearText);
    }
    window.location.href =
      "/collections/" +
      sanitizeSlug(carTypeSelector.value) +
      "-" +
      sanitizeSlug(tempModelYearText);
  }
}
